import React from 'react';
import {
  Box,
  GDSStyleObject,
  Modal,
  Button,
  HeadingText,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { PRIMARY_CARE_LIBRARY_ASSET_KEYS } from '../types/pcp-library.types';

import * as CONSTANTS from '../utils/constant';

export function AttentionBox(props: any) {
  const { handleAcceptFun, handleDeclineFun, openTermCondition, serviceName } =
    props;
  const InfoIcon = useStaticAsset(PRIMARY_CARE_LIBRARY_ASSET_KEYS.INFO_ICON);
  return (
    <Box>
      <Modal.Root open={openTermCondition} data-testid="tearms-modal">
        <Modal.Content
          showCloseButton={false}
          padding={{
            '@initial': '50px 50px 30px 50px',
            '@laptop': '50px 50px 30px 50px',
            '@tablet': '30px 30px',
            '@mobile': '30px',
          }}
          width={{
            '@initial': '695px',
            '@laptop': '695px',
            '@mobile': '100%',
            '@tablet': '80%',
          }}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <Box
            css={
              {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              } as GDSStyleObject
            }
          >
            <img src={InfoIcon as string} alt="close the online form" />
            <Modal.Title>
              <HeadingText
                level="display"
                size="sm"
                css={
                  {
                    fontWeight: '700',
                    fontSize: '24px',
                    textAlign: 'center',
                    padding: '26px 0px',
                    lineHeight: '32px',
                    color: '#2C3135',
                    letterSpacing: '0.25px',
                  } as GDSStyleObject
                }
              >
                {CONSTANTS.PRIMARY_CARE_PROVIDER_ATTENSIONBOX_TITLE}
              </HeadingText>
            </Modal.Title>
            <Box
              css={
                {
                  '@mobile': { maxWidth: '357px' },
                  '@desktop': { width: '545px' },
                  '@laptop': { width: '545px' },
                  '@mobileLandscape': { width: '545px' },
                  '@tablet': { width: '545px' },
                } as GDSStyleObject
              }
            >
              <HeadingText
                level="display"
                size="sm"
                css={
                  {
                    fontSize: '20px',
                    fontWeight: '700',
                    // padding: '18px 0px',
                    lineHeight: '32px',
                    textAlign: 'center',
                    color: '#2C3135',
                    fontStyle: 'normal',
                    letterSpacing: '0.25px',
                  } as GDSStyleObject
                }
              >
                {serviceName?.name === 'Kyruus'
                  ? CONSTANTS.PRIMARY_CARE_PROVIDER_ATTENSIONBOX_SUB_TITLE_KYRUUS
                  : CONSTANTS.PRIMARY_CARE_PROVIDER_ATTENSIONBOX_SUB_TITLE}
              </HeadingText>
            </Box>
            <Box
              css={
                {
                  '@mobile': { maxWidth: '357px' },
                  '@desktop': { maxWidth: '545px' },
                  '@laptop': { maxWidth: '545px' },
                  '@mobileLandscape': { maxWidth: '545px' },
                  '@tablet': { maxWidth: '545px' },
                } as GDSStyleObject
              }
            >
              <HeadingText
                level="display"
                size="sm"
                css={
                  {
                    fontSize: '16px',
                    padding: '22px 0px',
                    fontWeight: '400',
                    color: 'rgba(0, 0, 0, 0.80)',
                    fontFamily: 'Roboto',
                    fontStyle: 'normal',
                    letterSpacing: '-0.176px',
                    '@mobile': { textAlign: 'left' },
                    '@laptop': { textAlign: 'center' },
                    '@desktop': { textAlign: 'center' },
                    '@tablet': { textAlign: 'center' },
                  } as GDSStyleObject
                }
              >
                {CONSTANTS.PRIMARY_CARE_PROVIDER_ATTENSIONBOX_BODY}
              </HeadingText>
            </Box>
          </Box>
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'row',
                padding: '$one',
                justifyContent: 'center',
                gap: 60,
              } as GDSStyleObject
            }
          >
            <Button
              css={
                {
                  borderRadius: '99999px',
                  background: '#0074C9',
                  color: '#FFF',
                  fontSize: 16,
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '24px',
                  letterSpacing: '-0.2px',
                  textAlign: 'center',
                  display: 'flex',
                  padding: '8px 16px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  '&:hover': {
                    color: '#fff',
                  },
                } as GDSStyleObject
              }
              onClick={handleAcceptFun}
            >
              Continue
            </Button>
            <Button
              css={
                {
                  borderRadius: '99999px',
                  border: '1px solid #707E89',
                  background: '#FFFFFF',
                  color: '#434B51',
                  fontSize: 16,
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '24px',
                  letterSpacing: '-0.2px',
                  textAlign: 'center',
                  display: 'flex',
                  padding: '8px 16px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  '&:hover': {
                    color: '#fff',
                  },
                } as GDSStyleObject
              }
              onClick={handleDeclineFun}
            >
              Cancel
            </Button>
          </Box>
        </Modal.Content>
      </Modal.Root>
    </Box>
  );
}
